import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IBillingBalance } from '@dch/billing-business-logic';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { map, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { BILLING_BALANCE_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY,
  JWT_EXPIRED_TOKEN_CODE,
} from 'src/app/my-bill/config/my-bill.constants';
import { RemoteLoggerService } from 'src/app/my-bill/services/remote-logger.service';
import {
  getBillingBalanceFailure,
  getBillingBalanceRequest,
  getBillingBalanceSuccess,
} from '../actions/billing-balance.actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class BillingBalanceEffects {
  getBillingBlances$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBillingBalanceRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      switchMap(([action, customer]) =>
        EntityManager.getEntity<IBillingBalance>(BILLING_BALANCE_ENTITY, {
          cdbId: customer.customerId,
        }).pipe(
          map((entity) =>
            entity.value
              ? getBillingBalanceSuccess({
                  billingBalance: entity.value,
                })
              : getBillingBalanceFailure({})
          ),
          catchError((error) => {
            this.remoteLoggerService.logError(
              'Error while retrieving billing accounts',
              error
            );
            if (
              error?.errorData?.code === JWT_EXPIRED_TOKEN_CODE &&
              sessionStorage.getItem(
                SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY
              ) !== null
            ) {
              // remove smooth authentication session storage data when token expired
              sessionStorage.removeItem(
                SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY
              );
            }
            return of(
              getBillingBalanceFailure({ errorCode: error?.errorData?.code })
            );
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>,
    private remoteLoggerService: RemoteLoggerService
  ) {}
}
